// FETCH ALL ALL_OVER_PRINTING_DC_INWARD DETAILS
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE';

// FETCH ALL ALL_OVER_PRINTING_DC_INWARD DETAILS
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE';

// CREATE ALL_OVER_PRINTING_DC_INWARD DETAILS
export const CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST = 'CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE = 'CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE';

// UPDATE ALL_OVER_PRINTING_DC_INWARD DETAILS
export const UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST = 'UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE = 'UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STATE OF ALL_OVER_PRINTING_DC_INWARD DETAILS
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE';

// DELETE ALL_OVER_PRINTING_DC_INWARD DETAILS
export const DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST = 'DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE = 'DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM ALL_OVER_PRINTING_INWARD DETAILS
export const FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_FAILURE';

export const RESET_ALL_OVER_PRINTING_DC_INWARD_DETAILS_INFO = 'RESET_ALL_OVER_PRINTING_DC_INWARD_DETAILS_INFO';

export const CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FORM = 'CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FORM';

export const UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FORM = 'UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FORM';

export const ALL_OVER_PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED = 'ALL_OVER_PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED';
